<template>
  <div>
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="true"
        :is-full-page="fullPage"
        color="#018389"
        loader="dots"
      ></loading>
    </div>
    <v-toolbar flat color="white">
      <v-layout row wrap style="margin-left: 0px!important;">
       
        <v-flex xs9>
        </v-flex>
        <v-flex xs3>
          <v-text-field
              v-model="search"
              append-icon="search"
              label="Pretraga"
              xs5
              hide-details
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-toolbar>
    <v-layout column>
      <v-flex style="overflow: auto">
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          hide-actions
          class="elevation-1"
          :pagination.sync="pagination"
        >
          <template slot="headers" slot-scope="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '', header.align === 'left' ? 'text-xs-left' : 'text-xs-center']"
                @click="changeSort(header.value)"
              >
                <v-icon small v-if="header.sortable !== false"
                      >arrow_upward</v-icon
                    >
                {{ header.text }}
              </th>
            </tr>
          </template>

          <template slot="items" slot-scope="props">
            <tr>
              <td style="display:none;">{{ props.item.id }}</td>
              <td>{{ props.item.firstName }}</td>
              <td>{{ props.item.lastName }}</td>
              <td>{{ props.item.identityNumber }}</td>
              <td>{{ formatDateTime(props.item.dateOfBirth) }}</td>
              <!-- <td>{{ props.item.dateOfBirth }}</td> -->
              <td>{{ props.item.country }}</td>
              <td>{{ props.item.city }}</td>
              <td>{{ props.item.address }}</td>
              <td>{{ props.item.mobile }}</td>
              <td>{{ props.item.email }}</td>
              <td>{{ props.item.workingPosition }}</td>
              <td style="display:none;"><qr-code :class="napraviKlasu(props.item.id)"  :text="tekstZaQRkod(props.item)"></qr-code></td>
              

              <td class="DataTable__ButtonHolder">
                <img
                  class="DataTable__Button"
                  title="Izmena"
                  src="../assets/icons/zatabele/ico-edit2.svg"
                  alt="ulaz-grozdja"
                  @click="editItem(props.item)"
                >

                <img
                  class="DataTable__Button"
                  title="Brisanje"
                  src="../assets/icons/zatabele/ico-delete2.svg"
                  alt="delete-item"
                  @click="deleteItem(props.item)"
                >
                <img
                        class="DataTable__Button"
                        title="Štampa QR koda"
                        src="../assets/icons/zatabele/ico-print.png"
                        alt="delete-item"
                        @click="stampaj(props.item)"
                      />
              </td>
            </tr>
          </template>
          <template slot="no-data">
            <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
            <v-alert slot="no-results" :value="true" color="primary" icon="info">Nema podataka.</v-alert>
          </template>
          <v-alert
            slot="no-results"
            :value="true"
            color="error"
            icon="warning"
          >Trazili ste "{{ search }}" ali nema rezultata.</v-alert>
        </v-data-table>
      </v-flex>
    </v-layout>
    <TokenComponent ref="frmtoken"/>

  </div>
</template>


<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import { serverBus } from "../main";
import { readJSON, scrollToTopBasNaVrh } from "../helpers/Functions";
import TokenComponent from "../components/Token";
import html2pdf from "html2pdf.js";

export default {
  name: "PhaseTable",
  props: {
    msg: String
  },
  components: {
      TokenComponent,
      Loading,
    },
  data: () => ({
    isLoading: false,
    fullPage: true,
    pagination: {
      sortBy: "name",
      rowsPerPage: 10000000
    },
    search: "",
    headers: [
      // {
      // 	text: "ID",
      // 	align: "left",
      // 	sortable: true,
      // 	value: "id"
      // },
      { text: "Ime", value: "firstName", align: "left" },
      { text: "Prezime", value: "lastName", align: "left" },
      { text: "JMBG", value: "identityNumber", align: "left" },
      { text: "Datum rođenja", value: "dateOfBirth", align: "left" },
      { text: "Država", value: "country", align: "left" },
      { text: "Mesto", value: "city", align: "left" },
      { text: "Adresa", value: "address", align: "left" },
      { text: "Telefon", value: "mobile", align: "left" },
      { text: "Email", value: "email", align: "left" },
      { text: "Pozicija", value: "workingPosition", align: "left" },
      { text: "Funkcije", value: "funkcije", sortable: false }
    ],
    items: [],
    editedIndex: -1,
    editedItem: {
      id: 0,
      name: "",
      description: ""
    },
    defaultItem: {
      id: 0,
      name: "",
      description: ""
    }
  }),
  methods: {
    napraviKlasu(id){
      return "qrcode_" + id;
    },
    tekstZaQRkod(item){
      return item.id + "|" + item.firstName + "|" + item.lastName;
    },
    stampajSve(items) {
      this.isLoading = true;

      setTimeout(() => {
        var elementToPrint = document.createElement("div");
        elementToPrint.style.margin = "0px 0px 0px 0px";

        var elementToPrint2 = document.createElement("p");
        elementToPrint2.innerHTML = "Spisak eksternih radnika";
            
        elementToPrint2.style.textAlign = "center";
        elementToPrint2.style.fontSize = "20px";
        elementToPrint.append(elementToPrint2);

        // var body = document.getElementsByTagName("body")[0];
        var tbl = document.createElement("table");
        var tr = document.createElement("tr"); // Header row
        for (var j = 0; j < 5; j++) {
          var th = document.createElement("th"); //column
          var text = "";

          if (j === 0) text = document.createTextNode("Rb");
          //cell
          else if (j === 1) text = document.createTextNode("Ime");
          //cell
          else if (j === 2) text = document.createTextNode("Prezime");
          //cell
          else if (j === 3) text = document.createTextNode("Pozicija");
          //cell
          else if (j === 4) text = document.createTextNode("QR kod");

          th.appendChild(text);

          if (j === 0) th.style.width = "5%";
          else if (j === 1) th.style.width = "20%";
          else if (j === 2) th.style.width = "20%";
          else if (j === 3) th.style.width = "30%";
          else if (j === 4) th.style.width = "25%";

          // if(j === 1)
          //         th.setAttribute('style','text-align :left; padding-left: 5px;');
          //       else
          //         th.setAttribute('style','text-align :center;');

          tr.appendChild(th);
        }

        tr.style.background = "#eaece5";
        tbl.appendChild(tr);

        var tblBody = document.createElement("tbody");

        for (var i = 0; i < items.length; i++) {
          var row = document.createElement("tr");

          for (var j = 0; j < 5; j++) {
            var cell = document.createElement("td");

            var cellText = "";

            if (j === 0) cellText = document.createTextNode(i + 1);
            //cell
            else if (j === 1) {
              cellText = document.createTextNode(
                  items[i].firstName
                );
                
            }
            //cell
            else if (j === 2) cellText = document.createTextNode(items[i].lastName);
            //cell
            else if (j === 3)
              cellText = document.createTextNode(items[i].workingPosition == null ? " - " : items[i].workingPosition
              );
            //cell
            else if (j === 4){
              cellText  = document.createElement("img");
              cellText.style.margin = "5px 5px 5px 5px";
              cellText.src = document.getElementsByClassName("qrcode_" + items[i].id)[0].getElementsByTagName('img')[0].src;
              cellText.width = 100;
              cellText.height = 100;

            }
              

            cell.appendChild(cellText);

            if (j === 1)
              cell.setAttribute(
                "style",
                "text-align :left; padding-left: 5px;"
              );
            else cell.setAttribute("style", "text-align :center;");

            row.appendChild(cell);
          }

          

          tblBody.appendChild(row);
        }

        tbl.setAttribute("border", "thin solid");
        tbl.style.borderCollapse = "collapse";
        tbl.style.width = "95%"
        // tbl.style.borderColor = "black";

        tbl.appendChild(tblBody);

        tbl.style.margin = "20px 0px 0px 2%";

        elementToPrint.appendChild(tbl);


        let _this = this;

        // html2pdf(elementToPrint, {
        //   margin: 1,
        //   filename: item.number + ".pdf",
        //   image: { type: "jpeg", quality: 0.98 },
        //   // html2canvas: { dpi: 192, letterRendering: true },
        //   html2canvas: { dpi: 300, scale: 2 },
        //   jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
        // }).then((response) => {
        //   this.isLoading = false;
        // });

        html2pdf(null, {
          margin: 1,
          // filename: item.number + ".pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { dpi: 300, scale: 2 },
          jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
        })
          .from(elementToPrint)
          .toPdf()
          .get("pdf")
          .then(function (pdf) {
            _this.isLoading = false;

            window.open(pdf.output("bloburl"), "_blank");
          });
      }, 10);
    },
    stampaj(item) {
      setTimeout(() => {
        var elementToPrint = document.createElement("div");
        elementToPrint.style.margin = "0px 0px 0px 0px";

        var elementToPrint2 = document.createElement("p");
        elementToPrint2.innerHTML = "QR code za eksternog radnika";
            
        elementToPrint2.style.textAlign = "center";
        elementToPrint2.style.fontSize = "20px";
        elementToPrint.append(elementToPrint2);


        var elementToPrint1 = document.createElement("p");
        elementToPrint1.innerHTML =
          "Ime:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
          item.firstName;
        elementToPrint1.style.margin = "25px 0px 0px 5%";
        elementToPrint1.style.fontSize = "14px";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.innerHTML =
          "Prezime:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
          item.lastName;
        elementToPrint1.style.margin = "5px 0px 0px 5%";
        elementToPrint1.style.fontSize = "14px";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.innerHTML =
          "Pozicija:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
          (item.workingPosition == null ? " - " : item.workingPosition);
        elementToPrint1.style.margin = "5px 0px 0px 5%";
        elementToPrint1.style.fontSize = "14px";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.innerHTML =
          "QR kod:";
        elementToPrint1.style.margin = "5px 0px 0px 5%";
        elementToPrint1.style.fontSize = "14px";
        elementToPrint.append(elementToPrint1);

        var img  = document.createElement("img");
        img.style.margin = "5px 0px 0px 15%";
        img.src = document.getElementsByClassName("qrcode_" + item.id)[0].getElementsByTagName('img')[0].src;
        img.width = 100;
        img.height = 100;

        elementToPrint.append(img);

        let _this = this;

        html2pdf(null, {
          margin: 1,
          // filename: item.number + ".pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { dpi: 300, scale: 2 },
          jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
        })
          .from(elementToPrint)
          .toPdf()
          .get("pdf")
          .then(function (pdf) {
            _this.isLoading = false;

            window.open(pdf.output("bloburl"), "_blank");
          });
      }, 10);
    },
    formatDateTime(date) {
      if (typeof date !== "undefined" && date !== null){

      let lokDate = date.split('T')[0];

      let month = lokDate.split('-')[1];
      let day = lokDate.split('-')[2];
      const year = lokDate.split('-')[0];

      return [day, month, year].join(".");
      }
      else
        return "";
    },
    deleteSifarnik(id) {
      this.$http
        .delete(this.globalServiceLocation + this.globalPort + "/external_work_force/delete/" + id, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          this.getAllSifarnik();
        })
        .catch(e => {
          if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {

                this.$http
        .delete(this.globalServiceLocation + this.globalPort + "/external_work_force/delete/" + id, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {

          this.getAllSifarnik();
        })
        .catch(e => {
          let pomError = readJSON(e.response.data.message);
          alert(pomError);
        });
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
        });
    },
    getAllSifarnik() {
      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/external_work_force/all", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          this.items = response.data;

        })
        .catch(e => {
          
          if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {

                this.$http
        .get(this.globalServiceLocation + this.globalPort + "/external_work_force/all", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          this.items = response.data;

        })
        .catch(e => {
          
          let pomError = readJSON(e.response.data.message);
          alert(pomError);
        });
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
        });
    },

    getAllSifarnikSaStampom() {
      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/external_work_force/all", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          this.items = response.data;
          this.stampajSve(this.items);
        })
        .catch(e => {
          
          if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {
                this.$http
        .get(this.globalServiceLocation + this.globalPort + "/external_work_force/all", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          this.items = response.data;
          this.stampajSve(this.items);
        })
        .catch(e => {
          let pomError = readJSON(e.response.data.message);
          alert(pomError);
        });
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
        });
    },
    changeSort(column) {
      if (column !== "funkcije")
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending;
        } else {
          this.pagination.sortBy = column;
          this.pagination.descending = false;
        }
    },
    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);

scrollToTopBasNaVrh();

      serverBus.$emit("applied_external_work_force", item);
    },

    deleteItem(item) {
      const index = this.items.indexOf(item);
      confirm("Da li ste sigurni da želite obrisati izabrani zapis?") &&
        this.deleteSifarnik(item.id);
    }
  },
  mounted() {
    this.getAllSifarnik();

    serverBus.$on("refresh_external_work_force", () => {
      //alert(item.name);
      this.getAllSifarnik();
    });

    serverBus.$on("print_external_work_force", () => {
      this.getAllSifarnikSaStampom();
    });
  }
};
</script>
